import { formatEndpoint } from '@frontend/duck-tape';

const namespace = 'accounts/password';

export const PASSWORD_ENDPOINTS = {
  changePassword: () => formatEndpoint('change', namespace),
  forgotPassword: () => formatEndpoint('forgot', namespace),
  resetPassword: () => formatEndpoint('reset', namespace),
};
